import React from 'react';

const Footer = () => {
  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <p>&copy; 2026 LogicraNetwork. All rights reserved.</p>
        <div className="footer-links">
          <a href="/terms">Terms & Conditions</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/support">Support</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;